<div class="flex flex-column align-items-start gap-3 align-self-stretch pb-4">
  <div class="flex flex-column gap-2 w-full">
    <label for="account-holder">
      {{ i18n.i18nLng()['ACCOUNTHOLDER'] }}
      @if (paymentData.status === 'LIVE') {
        <sup class="sps-sup">*</sup>
      }
    </label>
    <input pInputText
           id="account-holder"
           maxlength="70"
           [(ngModel)]="paymentData.accountHolder"
           [required]="paymentData.status === 'LIVE'"
           [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
           [ngClass]="paymentInvalidFlags?.accountHolder ? 'ng-invalid ng-dirty' : null"
           [attr.aria-invalid]="paymentInvalidFlags?.accountHolder"
           [attr.aria-describedby]="paymentInvalidFlags?.accountHolder ? 'accountholder-invalid-help' : null"
           pSize="large" />
    @if (paymentInvalidFlags?.accountHolder) {
      <small style="line-height: 1.5rem" class="text-error" role="alert" id="accountholder-invalid-help">{{ i18n.i18nLng()['REQUIREDHELP'] }}</small>
    }
  </div>
  <div class="flex flex-column gap-2 w-full">
    <label for="IBAN">
      IBAN
      @if (paymentData.status === 'LIVE') {
        <sup class="sps-sup">*</sup>
      }
    </label>
    <p-inputmask
        [styleClass]="paymentData.IBAN && paymentData.IBAN.length > 0 ? 'w-full uppercase' : 'w-full'"
        inputId="IBAN"
        ariaLabel="IBAN"
        [(ngModel)]="paymentData.IBAN"
        [autoClear]="false"
        mask="DE99 9999 9999 9999 9999 99"
        slotChar=""
        [required]="paymentData.status === 'LIVE'"
        [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
        [attr.aria-invalid]="showInvalidIBAN"
        [ngClass]="paymentInvalidFlags?.IBAN ? 'ng-invalid ng-dirty' : null"
        (onComplete)="checkIBAN()"
        size="large"/>
    @if (showInvalidIBAN) {
      <small style="line-height: 1.5rem" class="text-error" role="alert" id="IBAN-invalid-help">{{ i18n.i18nLng()['INVALIDIBANHELP'] }}</small>
    }
  </div>
  <div class="flex flex-column gap-2 w-full">
    <label for="BIC">
      BIC
      @if (paymentData.status === 'LIVE') {
        <sup class="sps-sup">*</sup>
      }
    </label>
    <input pInputText
           id="BIC"
           maxlength="11"
           [(ngModel)]="paymentData.BIC"
           [required]="paymentData.status === 'LIVE'"
           [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
           [ngClass]="paymentInvalidFlags?.BIC ? 'ng-invalid ng-dirty' : (paymentData.BIC && paymentData.BIC.length > 0) ? 'uppercase' : null"
           [attr.aria-invalid]="paymentInvalidFlags?.BIC"
           [attr.aria-describedby]="paymentInvalidFlags?.BIC ? 'bic-invalid-help' : null"
           pSize="large" />
    @if (paymentInvalidFlags?.BIC) {
      <small style="line-height: 1.5rem" class="text-error" role="alert" id="bic-invalid-help">{{ i18n.i18nLng()['REQUIREDHELP'] }}</small>
    }
  </div>
  <div class="flex flex-column gap-2 w-full">
    <label for="bank">
      {{ i18n.i18nLng()['BANK'] }}
      @if (paymentData.status === 'LIVE') {
        <sup class="sps-sup">*</sup>
      }
    </label>
    <input pInputText
           id="bank"
           maxlength="70"
           [(ngModel)]="paymentData.bank"
           [required]="paymentData.status === 'LIVE'"
           [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
           [ngClass]="paymentInvalidFlags?.bank ? 'ng-invalid ng-dirty' : null"
           [attr.aria-invalid]="paymentInvalidFlags?.bank"
           [attr.aria-describedby]="paymentInvalidFlags?.bank ? 'bank-invalid-help' : null"
           pSize="large" />
  </div>
</div>
